import { graphql } from "~/gql";
import { useQuery, useMutation } from "@apollo/client";

const UPDATE_CLIENT_REPORT_HTML = graphql(/* GraphQL */ `
  mutation UpdateClientReportHtml($update: UpdateClientReportOutputInput!) {
    updateClientReportHtml(update: $update)
  }
`);

export const CLIENT_REPORT_BY_MATTER_ID = graphql(/* GraphQL */ `
  query ClientReportByMatterId($matterId: Float!, $costProjectionSvgString: String!) {
    clientReportByMatterId(matterId: $matterId, costProjectionSvgString: $costProjectionSvgString) {
      html
      clientReport {
        matterTitle
        clientName
        currencySymbol
        plannedFee {
          ...PriceParts
          ...PriceRangeParts
        }
        actualFee
        overBudget
        invoices {
          id
          description
          date
          status
          totalFeeNet
        }
        amountBilled
        amountPaid
        billingChart
        includeBillingChart
        costProjectionDiagram
        includeCostProjectionDiagram
        cumulativeAccruedFees {
          date
          amount
        }
        matterCompletionLogs {
          createdAt
          completionPercentage
        }
        deadline
      }
      outputTemplateId
      outputTemplateName
    }
  }
`);

export const UPDATE_CLIENT_REPORT_OPTIONS = graphql(/* GraphQL */ `
  mutation UpdateClientReportOptions($updateOptions: UpdateClientReportOptionsInput!) {
    updateClientReportOptions(updateOptions: $updateOptions) {
      includeCostProjectionDiagram
      includeBillingChart
    }
  }
`);

export type ClientReportOptions = {
  includeCostProjectionDiagram?: boolean;
  includeBillingChart?: boolean;
};

export const useVpdClientReportEngine = (matterId: number, costProjectionSvgString: string) => {
  const [updateClientReportHtml] = useMutation(UPDATE_CLIENT_REPORT_HTML);

  // Get the server parsed html.
  const {
    loading: isLoading,
    data: initialCompiledContent,
    refetch,
  } = useQuery(CLIENT_REPORT_BY_MATTER_ID, {
    variables: { matterId, costProjectionSvgString },
    fetchPolicy: "network-only",
  });

  return {
    initialCompiledContent: initialCompiledContent?.clientReportByMatterId,
    isLoading,
    updateClientReportHtml,
    refetch,
  };
};
